import React from "react";
import { cn, formControlClass } from "./formStyles";

const FileInput = React.forwardRef(function FileInput(
  { className = "", invalid = false, ...props },
  ref
) {
  return (
    <input
      ref={ref}
      type="file"
      className={cn(
        formControlClass,
        "file:mr-3 file:rounded-md file:border-0 file:bg-blue-600 file:px-3 file:py-2 file:text-sm file:font-medium file:text-white hover:file:bg-blue-700",
        invalid && "border-red-500 focus:ring-red-500",
        className
      )}
      {...props}
    />
  );
});

export default FileInput;
